<template>
  <b-row class="row-height my-1">
    <b-col
      class="p-0"
      :class="{
        'col-5': option_show_kind !== 12,
        'col-6': option_show_kind == 12 && hiddenQuestionTitle == 0,
        'col-1': hiddenQuestionTitle == 1,
      }"
    >
      <div class="lightgray first-section-desgin">
        <h6 class="d-flex m-0" v-if="hiddenQuestionTitle == 0">
          {{ questionOrder }}.
          <div v-html="createPureDom(title)"></div>
        </h6>
        <h6 v-if="hiddenQuestionTitle == 1">
          {{ questionOrder }}
        </h6>
      </div>
      <span
        :class="`first-section-desgin-line ${answer_value ? `black` : `gray`} `"
      ></span>
    </b-col>
    <b-col
      :class="{
        'col-5': option_show_kind !== 12,
        'col-6': option_show_kind == 12 && hiddenQuestionTitle == 0,
        'col-11': hiddenQuestionTitle == 1,
      }"
    >
      <div class="lightgray second-section-desgin">
        <ul
          class="ul-square list-unstyled m-0 p-0 mobile-flex-direction-column tablet-flex-direction-column"
        >
          <li
            @click="answeQuestion(item, option, id)"
            ref="liOptionSquare"
            class="li-square"
            v-for="(option, index) in options"
            :key="index"
            :style="{
              width: checkScreenDevice(['desktop'])
                ? 100 / options.length + '%'
                : '100%',
            }"
          >
            <div v-if="option_show_kind == 11" :class="option.activeClass">
              {{ index + 1 }}
            </div>
            <div
              v-if="option_show_kind == 12"
              :class="`${option.selected ? `SquareActive` : `SquareNotActive`}`"
              v-html="createPureDom(option.option_description)"
            />
          </li>
        </ul>
      </div>
    </b-col>
    <b-col v-if="option_show_kind !== 12" class="col-12 col-md-2 my-pr">
      <div class="Third-section-desgin gray">
        <div
          class="line_option_description"
          v-if="answer_value"
          v-html="createPureDom(option_description)"
        ></div>
        <div class="line_option_description" v-else>؟</div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { checkScreenDevice } from "@/shared/utils";
import { pathOr } from "ramda";
import { createPureDom } from "@/shared/utils";
export default {
  props: {
    questionOrder: {
      type: [String, Number],
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    answer_value: {
      type: [String, Number],
      default: "",
    },
    item: {
      type: Object,
      default: () => {},
    },
    options: {
      type: Array,
      default: () => [],
    },
    id: {
      type: [String, Number],
      default: "",
    },
    option_description: {
      type: [String],
      default: "",
    },
    option_show_kind: {
      type: [String, Number],
      default: "",
    },
    hiddenQuestionTitle: {
      type: [String, Number],
      default: "",
    },
  },
  methods: {
    createPureDom,
    pathOr,
    checkScreenDevice,
    answeQuestion(item, option, id) {
      this.$emit("answeQuestion", item, option, id);
    },
    getClassStyle(option, index) {
      return this.answer_value >= index + 1
        ? `SquareActive`
        : `SquareNotActive`;
    },
  },
};
</script>

<style lang="scss">
.layout {
  width: 100%;
}

.section-desgin {
  display: flex;
  justify-content: center;
  align-items: center;
  // height: 100vh;
}

.first-section-desgin {
  position: relative;
  padding: 10px;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  // white-space: pre;
  p {
    margin: 0 !important;
  }
}

.row-height {
  min-height: 60px;
}

.first-section-desgin-line {
  height: 100%;
  width: 8px;
  position: absolute;

  top: 0;
  left: 0;
}

.second-section-desgin {
  height: 100%;
}

.lightgray {
  background-color: #f1f1f1;
  // padding: 0px !important;
}

// .row-min-height {
//   min-height: 70px;
// }

.gray {
  padding: 0px !important;
  background-color: #cbcbcb;
}

.black {
  background-color: #243c44 !important;
}

.Third-section-desgin {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.ul-square {
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;

  .li-square {
    padding: 5px;
    height: 80%;
    // flex: auto;
    // justify-content: center;
    // align-items: center;
    // display: flex;
    cursor: pointer;
  }
}

.SquareNotActive {
  background-color: lightgray;
  // padding: 8px;
  width: 100%;
  padding: 1px;
  height: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  p {
    padding: 0 !important;
    margin: 0 !important;
  }
}

.SquareActive {
  // padding: 8px;
  padding: 1px;
  width: 100%;
  height: 100%;
  text-align: center;
  background-color: #243c44;
  color: white;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;

  /* margin: 5px 0; */
  p {
    padding: 0 !important;
    margin: 0 !important;
  }
}

.my-pr {
  padding-right: 0;
}

.my-pl {
  padding-left: 0;
}

@media (max-width: 767px) {
  .my-pl {
    padding-right: 15px;
    padding-left: 15px;
  }

  .my-pr {
    padding-right: 15px;
    padding-left: 15px;
  }

  .row-height {
    min-height: 150px;
  }

  .first-section-desgin-line {
    display: none;
  }
}

.line_option_description {
  p {
    margin: 0 !important;
    padding: 0 !important;
  }
}
</style>
